import { SortEnumType } from '@/generated/graphql'

export const sortFields = [
  {
    slug: 'newest',
    name: 'Newest first',
    value: {
      dateAdded: SortEnumType.Desc,
    },
  },
  {
    slug: 'oldest',
    name: 'Oldest first',
    value: {
      dateAdded: SortEnumType.Asc,
    },
  },
  {
    slug: 'a-to-z',
    name: 'Name (A-Z)',
    value: {
      name: SortEnumType.Asc,
    },
  },
  {
    slug: 'z-to-a',
    name: 'Name (Z-A)',
    value: {
      name: SortEnumType.Desc,
    },
  },
  {
    slug: 'price-low-to-high',
    name: 'Price (cheapest first)',
    value: {
      displayPrice: SortEnumType.Asc,
    },
  },
  {
    slug: 'price-high-to-low',
    name: 'Price (most expensive first)',
    value: {
      displayPrice: SortEnumType.Desc,
    },
  },
  {
    slug: 'top-rated',
    name: 'Top rated',
    value: {
      rating: SortEnumType.Desc,
    },
  },
  {
    slug: 'best-selling',
    name: 'Best selling',
    value: {
      salesRank: SortEnumType.Asc,
    },
  },
]
